 
import { createContext } from 'utils/react-helpers';

const [TravelProvider, useTravel] = createContext('TravelContext');

export { TravelProvider, useTravel };
